import { ISearchFilter } from "../../typings/Filters";
import { ILocationFilter } from "../../typings/SourcingToolFilters/LocationFilter";

export default (x: ISearchFilter): x is ILocationFilter => x.type === "location";
